import Splide from '@splidejs/splide';

$(document).ready(function() {


    if ( elementExistsById("splide") ) {
		new Splide( '#splide', {
			type: 'loop',
			perPage: 1,
			perMove: 1,
			rewind: true,
			pagination:false,
			height    : '420px',
			breakpoints: {
				768: {
					perPage: 1,
					height    : '200px',
				},
			}
		} ).mount();
    }

    if ( elementExistsById( "newsCarousel" ) ) {
		new Splide( '#newsCarousel', {
			// type		: 'loop',
			perPage		: 3,
			perMove		: 1,
			rewind		: true,
			pagination	: false,
			breakpoints	: {
				768: {
					perPage: 1,
				},
			}
		} ).mount();
	}

});

function elementExistsById(id) {
    let element = document.getElementById(id);
	return typeof(element) != 'undefined' && element != null;
}
